export function scrollTo(_a) {
    var top = _a.top, left = _a.left, smooth = _a.smooth;
    try {
        var to = { left: left, top: top };
        if (smooth === true) {
            to.behavior = 'smooth';
        }
        window.scrollTo(to);
    }
    catch (e) {
        window.scrollTo(left, top);
    }
}
//# sourceMappingURL=scrollTo.js.map